import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { useWorkshopBoard } from '../../functions/useWorkshopBoard';
import { MetricStrip } from '../metric-strip';
import { TaskTable } from '../task-table';

/** The 工单 board: today's counts over the open tasks. */
export const TaskBoard = memo(({ now }: { now: Date }) => {
  const u = useBoardUnit();
  const board = useWorkshopBoard();
  const ready = board.kind === 'ready' ? board : null;
  return (
    <View style={{ flex: 1, gap: u(28) }}>
      <MetricStrip
        tasks={ready?.value.tasks ?? null}
        stats={ready?.value.stats ?? null}
      />
      <TaskTable
        tasks={
          board.kind === 'ready'
            ? { ...board, value: board.value.tasks }
            : board
        }
        now={now}
      />
    </View>
  );
});
